import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: 360,
    flexShrink: 0,
    borderLeft: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  moduleHeader: {
    padding: theme.spacing(1.75, 2),
    cursor: 'pointer',
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:hover': {
      backgroundColor: theme.palette.background.default,
    },
  },
  moduleHeaderInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  moduleHeaderText: {
    flex: 1,
    minWidth: 0,
  },
  moduleTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.25),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  moduleMeta: {
    fontSize: 11,
    color: theme.palette.text.secondary,
  },
  chevron: {
    color: theme.palette.text.secondary,
    flexShrink: 0,
    marginLeft: theme.spacing(1),
  },
  lessonRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.25, 2),
    cursor: 'pointer',
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderLeft: '3px solid transparent',
    transition: 'background-color 0.1s, border-left-color 0.1s',
    '&:hover': {
      backgroundColor: theme.palette.background.default,
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  lessonRowActive: {
    borderLeftColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.light,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  lessonLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flex: 1,
    minWidth: 0,
  },
  checkIcon: {
    fontSize: 18,
    color: theme.palette.divider,
    flexShrink: 0,
  },
  checkIconCompleted: {
    color: theme.palette.statusLabel.success.primary,
  },
  lessonTitle: {
    fontSize: 13,
    color: theme.palette.text.primary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  lessonRight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    flexShrink: 0,
    marginLeft: theme.spacing(1),
  },
  lessonMeta: {
    fontSize: 11,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
}))

export default useStyles
